export default "__VITE_ASSET__BuGmQS4k__"